import { colors } from '../../../../../colorVars';
import { Body2 } from '../../../../atomic/text/Text';
import style from './TradePlanHubListItem.module.css';

type Props = {
  selectedTradePlan: string;
  setSelectedTradePlan: (tradePlanId: string) => void;
  previous: string;
  lastItem: boolean;
};

export const NewPlanListItem = ({
  selectedTradePlan,
  setSelectedTradePlan,
  previous,
  lastItem,
}: Props) => {
  const tradePlanId = 'newTradePlan';
  return (
    <li
      onClick={() => setSelectedTradePlan(tradePlanId)}
      className={
        selectedTradePlan === tradePlanId
          ? style.selectedListItem
          : selectedTradePlan === previous && !lastItem
          ? style.afterSelected
          : style.listItem
      }
    >
      <div
        style={{
          height: '64.5px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Body2 color={colors.lightGrey} fontWeight={600}>
          + New Trade Plan
        </Body2>
      </div>
    </li>
  );
};
